import { apiV2 } from '@newtontechnologies/beey-api-js-client/endpoints';
export const sendLogs = async (logs) => {
    const body = JSON.stringify(logs);
    return fetch(apiV2.log.url(), {
        method: 'POST',
        cache: 'no-cache',
        headers: {
            'Content-Type': 'application/json',
        },
        body,
    });
};
